/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Benchmark } from '@coin/shared/core/util-models-v2';
import { CreateDeputy } from '@coin/shared/core/util-models-v2';
import { Deputy } from '@coin/shared/core/util-models-v2';
import { DirectsPositionClassComparison } from '@coin/shared/core/util-models-v2';
import { EmployeeProfile } from '@coin/shared/core/util-models-v2';
import { FullEmployee } from '@coin/shared/core/util-models-v2';
import { OwnEmployee } from '@coin/shared/core/util-models-v2';
import { PageOfDeputy } from '@coin/shared/core/util-models-v2';
import { PlanDetails } from '@coin/shared/core/util-models-v2';
import { SecuritySettings } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface CreateDeputiesParams {
  /** The model to create the deputy with. */
  createDeputy?: CreateDeputy;
}

export interface DeleteDeputiesParams {
  /** The unique id of the deputy to delete. */
  id: string;
}

export interface EmployeesCustomerGetByGidEmployeesParams {
  /** The unique gid of the employee to find. */
  gid: string;
}

export interface EmployeesCustomerGetEmployeesParams {
  /** The unique id of the existing employee to find. */
  id: string;
  /** The season type of which to collect additional information. */
  seasonType?:
    | 'Unknown'
    | 'SOG'
    | 'GBR'
    | 'Merit'
    | 'IncentiveV2'
    | 'SpecialPaymentCash'
    | 'SpecialPaymentEquity'
    | 'PositionEvaluation'
    | 'Restructuring';
}

export interface GetBenchmarksEmployeesParams {
  /** The unique id of the employee to find benchmarks of. */
  id: string;
  /** The season type of which to collect additional information. */
  seasonType?:
    | 'Unknown'
    | 'SOG'
    | 'GBR'
    | 'Merit'
    | 'IncentiveV2'
    | 'SpecialPaymentCash'
    | 'SpecialPaymentEquity'
    | 'PositionEvaluation'
    | 'Restructuring';
}

export interface GetIncentivePlanDetailsForEmployeeByRecordIdProfilesParams {
  id: string;
  recordId: string;
}

export interface GetPositionClassComparisonsEmployeesParams {
  /** The unique id of the employee to request position class comparisons of. */
  id: string;
  /** The optional org code to filter directs with. */
  orgCode?: string;
}

export interface GetProfilesParams {
  /** The unique id of the employees profile. */
  id: string;
}

export interface GetSecuritySettingsEmployeesParams {
  /** The unique id of the employee to find the security settings of. */
  id: string;
  /**  */
  seasonId?: string;
}

export interface QueryDeputiesParams {
  /** If set to true, the query will switch from deputies to returning emulatable employees. */
  forEmulation?: boolean;
  /** If set to true, the query will switch from actual deputies to querying the potential deputies. */
  allPotentials?: boolean;
  /** The gid to find. */
  queryGid?: string;
  /** The name to find. */
  queryName?: string;
  /** The firstname to find. */
  queryFirstname?: string;
  /** The lastname to find. */
  queryLastname?: string;
  /** The place of action to find. */
  queryPlaceOfAction?: Array<string>;
  /** The orgcode to find. */
  queryOrgCode?: string;
  queryPage?: number;
  querySize?: number;
  pagingPage?: number;
  pagingSize?: number;
}

@Injectable({
  providedIn: 'root'
})
export class EmployeesCustomerService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * Creates a new deputy for the current requesting user.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createDeputies(
    requestParameters?: CreateDeputiesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Deputy>;
  public createDeputies(
    requestParameters?: CreateDeputiesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Deputy>>;
  public createDeputies(
    requestParameters?: CreateDeputiesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Deputy>>;
  public createDeputies(requestParameters?: CreateDeputiesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/customer/api/v1/master/employees/deputies`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createDeputy,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Deletes an existing deputy.
   * Only removes the deputy. Employee information is unchanged.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteDeputies(
    requestParameters?: DeleteDeputiesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<boolean>;
  public deleteDeputies(
    requestParameters?: DeleteDeputiesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<boolean>>;
  public deleteDeputies(
    requestParameters?: DeleteDeputiesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<boolean>>;
  public deleteDeputies(requestParameters?: DeleteDeputiesParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deleteDeputies', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/customer/api/v1/master/employees/deputies/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Finds an employee by its unique gid.
   * Limited to only allowing quering this data if the gid is the requesters own gid.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employeesCustomerGetByGidEmployees(
    requestParameters?: EmployeesCustomerGetByGidEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OwnEmployee>;
  public employeesCustomerGetByGidEmployees(
    requestParameters?: EmployeesCustomerGetByGidEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OwnEmployee>>;
  public employeesCustomerGetByGidEmployees(
    requestParameters?: EmployeesCustomerGetByGidEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OwnEmployee>>;
  public employeesCustomerGetByGidEmployees(
    requestParameters?: EmployeesCustomerGetByGidEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const gid = requestParameters?.gid;
    this.checkRequired('employeesCustomerGetByGidEmployees', { gid });
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/employees/gid/${this.configuration.encodeParam({ name: 'gid', value: gid, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets an existing employee by its unique id and optionally populates season specific data if the request includes information about the seasons type.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employeesCustomerGetEmployees(
    requestParameters?: EmployeesCustomerGetEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<FullEmployee>;
  public employeesCustomerGetEmployees(
    requestParameters?: EmployeesCustomerGetEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<FullEmployee>>;
  public employeesCustomerGetEmployees(
    requestParameters?: EmployeesCustomerGetEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<FullEmployee>>;
  public employeesCustomerGetEmployees(
    requestParameters?: EmployeesCustomerGetEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('employeesCustomerGetEmployees', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/employees/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { SeasonType: requestParameters?.seasonType }
    });
  }

  /**
   * Gets benchmark values of an existing employee by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getBenchmarksEmployees(
    requestParameters?: GetBenchmarksEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<Benchmark>>;
  public getBenchmarksEmployees(
    requestParameters?: GetBenchmarksEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<Benchmark>>>;
  public getBenchmarksEmployees(
    requestParameters?: GetBenchmarksEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<Benchmark>>>;
  public getBenchmarksEmployees(
    requestParameters?: GetBenchmarksEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getBenchmarksEmployees', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/employees/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/benchmarks`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { SeasonType: requestParameters?.seasonType }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getIncentivePlanDetailsForEmployeeByRecordIdProfiles(
    requestParameters?: GetIncentivePlanDetailsForEmployeeByRecordIdProfilesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PlanDetails>;
  public getIncentivePlanDetailsForEmployeeByRecordIdProfiles(
    requestParameters?: GetIncentivePlanDetailsForEmployeeByRecordIdProfilesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PlanDetails>>;
  public getIncentivePlanDetailsForEmployeeByRecordIdProfiles(
    requestParameters?: GetIncentivePlanDetailsForEmployeeByRecordIdProfilesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PlanDetails>>;
  public getIncentivePlanDetailsForEmployeeByRecordIdProfiles(
    requestParameters?: GetIncentivePlanDetailsForEmployeeByRecordIdProfilesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const recordId = requestParameters?.recordId;
    this.checkRequired('getIncentivePlanDetailsForEmployeeByRecordIdProfiles', { id, recordId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/employee-profile/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/incentive-data/${this.configuration.encodeParam({ name: 'recordId', value: recordId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets a list of directs of an employee with their position class.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPositionClassComparisonsEmployees(
    requestParameters?: GetPositionClassComparisonsEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<DirectsPositionClassComparison>>;
  public getPositionClassComparisonsEmployees(
    requestParameters?: GetPositionClassComparisonsEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<DirectsPositionClassComparison>>>;
  public getPositionClassComparisonsEmployees(
    requestParameters?: GetPositionClassComparisonsEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<DirectsPositionClassComparison>>>;
  public getPositionClassComparisonsEmployees(
    requestParameters?: GetPositionClassComparisonsEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getPositionClassComparisonsEmployees', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/employees/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/directs/position-class-comparisons`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { orgCode: requestParameters?.orgCode }
    });
  }

  /**
   * Gets an existing employees profile by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getProfiles(
    requestParameters?: GetProfilesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeProfile>;
  public getProfiles(
    requestParameters?: GetProfilesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeProfile>>;
  public getProfiles(
    requestParameters?: GetProfilesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeProfile>>;
  public getProfiles(requestParameters?: GetProfilesParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getProfiles', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/employee-profile/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets the security settings of an existing employee by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSecuritySettingsEmployees(
    requestParameters?: GetSecuritySettingsEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SecuritySettings>;
  public getSecuritySettingsEmployees(
    requestParameters?: GetSecuritySettingsEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SecuritySettings>>;
  public getSecuritySettingsEmployees(
    requestParameters?: GetSecuritySettingsEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SecuritySettings>>;
  public getSecuritySettingsEmployees(
    requestParameters?: GetSecuritySettingsEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getSecuritySettingsEmployees', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/employees/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/security-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { seasonId: requestParameters?.seasonId }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryDeputies(
    requestParameters?: QueryDeputiesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfDeputy>;
  public queryDeputies(
    requestParameters?: QueryDeputiesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfDeputy>>;
  public queryDeputies(
    requestParameters?: QueryDeputiesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfDeputy>>;
  public queryDeputies(requestParameters?: QueryDeputiesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/employees/deputies`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        ForEmulation: requestParameters?.forEmulation,
        AllPotentials: requestParameters?.allPotentials,
        'Query.Gid': requestParameters?.queryGid,
        'Query.Name': requestParameters?.queryName,
        'Query.Firstname': requestParameters?.queryFirstname,
        'Query.Lastname': requestParameters?.queryLastname,
        'Query.PlaceOfAction': requestParameters?.queryPlaceOfAction,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.Page': requestParameters?.queryPage,
        'Query.Size': requestParameters?.querySize,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize
      }
    });
  }
}
